import styled from 'styled-components'

export const SkeletonAllAssets = () => {
  return (
    <SContainer>
      <SSection>
        <SkeletonBlock width="120px"
          height="24px"
          marginBottom="24px"
        />

        <SAssetsGrid>
          {[...Array(8)].map((_, index) => (
            <SAssetCard key={index}>
              <SkeletonBlock width="100%"
                height="160px"
              />
            </SAssetCard>
          ))}
        </SAssetsGrid>
      </SSection>
    </SContainer>
  )
}

const SkeletonBlock = styled.div<{ width: string; height: string; marginTop?: string; marginBottom?: string }>`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  width: ${props => props.width};
  height: ${props => props.height};
  margin-top: ${props => props.marginTop || '0'};
  margin-bottom: ${props => props.marginBottom || '0'};

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

const SContainer = styled.div`
  padding: 0 24px;
`

const SSection = styled.div`
  margin-top: 40px;
`

const SAssetsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(362px, 1fr));
  gap: 24px;
`

const SAssetCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
` 